import { ResetPassword } from "@/components/ResetPassword";

export const WebUserResetPassword = () => {
  return <ResetPassword resetRole="webUser"></ResetPassword>;
};
